import { render, staticRenderFns } from "./PaperTable.vue?vue&type=template&id=c1a61446"
import script from "./PaperTable.vue?vue&type=script&lang=js"
export * from "./PaperTable.vue?vue&type=script&lang=js"
import style0 from "./PaperTable.vue?vue&type=style&index=0&id=c1a61446&prod&lang=css"
import style1 from "./PaperTable.vue?vue&type=style&index=1&id=c1a61446&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports